import angular from 'angular'
import { ErrorBoundary } from '@vend/react-utilities'
import { trackError } from '@vend/utilities'

export const CORTEX_CHAT_CONTAINER_READY_EVENT = 'cortex-chat-container-ready'

const CORTEX_TOOLS_APP_NAME = '@vend-spa/cortex-tools'

type CortexToolsModule = {
  chat: {
    mountInto: (
      container: HTMLElement,
      options: {
        errorBoundaryClass?: unknown
        onError?: (error: unknown) => void
      }
    ) => () => void
  }
}

const loadCortexTools = (): Promise<CortexToolsModule> =>
  window.System.import(CORTEX_TOOLS_APP_NAME)

export const mountCortexChatContainer = (container: HTMLElement) => {
  let isDestroyed = false
  let unmount: (() => void) | undefined

  loadCortexTools()
    .then(({ chat }) => {
      if (isDestroyed) return

      try {
        unmount = chat.mountInto(container, {
          errorBoundaryClass: ErrorBoundary,
          onError: error => {
            trackError(error as Error, {
              message: 'Failed to mount Cortex chat in WebRegister',
            })
          },
        })
      } catch (error) {
        trackError(error as Error, {
          message: 'Failed to mount Cortex chat in WebRegister',
        })
      }
    })
    .catch((error: unknown) => {
      if (isDestroyed) return

      trackError(error as Error, {
        message: `Failed to load ${CORTEX_TOOLS_APP_NAME} in WebRegister`,
      })
    })

  return () => {
    isDestroyed = true
    unmount?.()
  }
}

angular
  .module('webregister.directives')
  .directive('wrCortexChatContainer', function ($timeout) {
    return {
      restrict: 'A',
      link(scope, $element) {
        let isDestroyed = false
        const unmount = mountCortexChatContainer($element[0])

        const readyEventTimeout = $timeout(() => {
          if (isDestroyed) return

          window.dispatchEvent(
            new CustomEvent(CORTEX_CHAT_CONTAINER_READY_EVENT)
          )
        })

        scope.$on('$destroy', () => {
          isDestroyed = true
          $timeout.cancel(readyEventTimeout)
          unmount()
        })
      },
    }
  })
